import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLayersAdd = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m17.42 9.921 1.64.888.4.225a1.26 1.26 0 0 1 0 2.194l-5.432 3.052a4.14 4.14 0 0 1-4.055 0L4.54 13.228a1.26 1.26 0 0 1 0-2.194l.4-.225 1.597-.914"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m17.49 14.334 1.811.921c.897.452.926 1.73.05 2.221l-5.324 2.992a4.14 4.14 0 0 1-4.054 0L4.726 17.52c-.89-.5-.842-1.806.084-2.238l1.825-.878M9.973 3.53 4.54 6.584a1.26 1.26 0 0 0 0 2.195l5.433 3.052a4.14 4.14 0 0 0 4.055 0l5.433-3.052a1.26 1.26 0 0 0 0-2.195l-5.433-3.052a4.14 4.14 0 0 0-4.055 0Z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLayersAdd);
export default ForwardRef;
